class StorageUtils {
  private features: Record<string, boolean> = {};

  private init(): void {
    const cacheFeatures = localStorage.getItem("features");
    this.features = JSON.parse(cacheFeatures || "{}");
  }

  public isFeatureEnabled(feature: string): boolean {
    if (!this.features || Object.keys(this.features).length === 0) {
      this.init();
    }

    return this.features[feature] || false;
  }
}

export default new StorageUtils();
